{
  "abi": [
    {
      "type": "constructor",
      "inputs": [
        {
          "name": "_registry",
          "type": "address",
          "internalType": "address"
        }
      ],
      "stateMutability": "nonpayable"
    },
    {
      "type": "function",
      "name": "BLS_AGGREGATOR",
      "inputs": [],
      "outputs": [
        {
          "name": "",
          "type": "address",
          "internalType": "address"
        }
      ],
      "stateMutability": "view"
    },
    {
      "type": "function",
      "name": "REGISTRY",
      "inputs": [],
      "outputs": [
        {
          "name": "",
          "type": "address",
          "internalType": "contract IRegistry"
        }
      ],
      "stateMutability": "view"
    },
    {
      "type": "function",
      "name": "addValidator",
      "inputs": [
        {
          "name": "_v",
          "type": "address",
          "internalType": "address"
        }
      ],
      "outputs": [],
      "stateMutability": "nonpayable"
    },
    {
      "type": "function",
      "name": "createProposal",
      "inputs": [
        {
          "name": "operator",
          "type": "address",
          "internalType": "address"
        },
        {
          "name": "level",
          "type": "uint8",
          "internalType": "uint8"
        },
        {
          "name": "reason",
          "type": "string",
          "internalType": "string"
        },
        {
          "name": "evidenceHash",
          "type": "bytes32",
          "internalType": "bytes32"
        }
      ],
      "outputs": [
        {
          "name": "id",
          "type": "uint256",
          "internalType": "uint256"
        }
      ],
      "stateMutability": "nonpayable"
    },
    {
      "type": "function",
      "name": "createProposal",
      "inputs": [
        {
          "name": "operator",
          "type": "address",
          "internalType": "address"
        },
        {
          "name": "level",
          "type": "uint8",
          "internalType": "uint8"
        },
        {
          "name": "reason",
          "type": "string",
          "internalType": "string"
        }
      ],
      "outputs": [
        {
          "name": "id",
          "type": "uint256",
          "internalType": "uint256"
        }
      ],
      "stateMutability": "nonpayable"
    },
    {
      "type": "function",
      "name": "executeWithProof",
      "inputs": [
        {
          "name": "id",
          "type": "uint256",
          "internalType": "uint256"
        },
        {
          "name": "repUsers",
          "type": "address[]",
          "internalType": "address[]"
        },
        {
          "name": "newScores",
          "type": "uint256[]",
          "internalType": "uint256[]"
        },
        {
          "name": "epoch",
          "type": "uint256",
          "internalType": "uint256"
        },
        {
          "name": "proof",
          "type": "bytes",
          "internalType": "bytes"
        }
      ],
      "outputs": [],
      "stateMutability": "nonpayable"
    },
    {
      "type": "function",
      "name": "isValidator",
      "inputs": [
        {
          "name": "",
          "type": "address",
          "internalType": "address"
        }
      ],
      "outputs": [
        {
          "name": "",
          "type": "bool",
          "internalType": "bool"
        }
      ],
      "stateMutability": "view"
    },
    {
      "type": "function",
      "name": "markProposalExecuted",
      "inputs": [
        {
          "name": "id",
          "type": "uint256",
          "internalType": "uint256"
        }
      ],
      "outputs": [],
      "stateMutability": "nonpayable"
    },
    {
      "type": "function",
      "name": "nextProposalId",
      "inputs": [],
      "outputs": [
        {
          "name": "",
          "type": "uint256",
          "internalType": "uint256"
        }
      ],
      "stateMutability": "view"
    },
    {
      "type": "function",
      "name": "owner",
      "inputs": [],
      "outputs": [
        {
          "name": "",
          "type": "address",
          "internalType": "address"
        }
      ],
      "stateMutability": "view"
    },
    {
      "type": "function",
      "name": "proposals",
      "inputs": [
        {
          "name": "",
          "type": "uint256",
          "internalType": "uint256"
        }
      ],
      "outputs": [
        {
          "name": "operator",
          "type": "address",
          "internalType": "address"
        },
        {
          "name": "slashLevel",
          "type": "uint8",
          "internalType": "uint8"
        },
        {
          "name": "reason",
          "type": "string",
          "internalType": "string"
        },
        {
          "name": "executed",
          "type": "bool",
          "internalType": "bool"
        },
        {
          "name": "exists",
          "type": "bool",
          "internalType": "bool"
        },
        {
          "name": "evidenceHash",
          "type": "bytes32",
          "internalType": "bytes32"
        }
      ],
      "stateMutability": "view"
    },
    {
      "type": "function",
      "name": "pruneValidator",
      "inputs": [
        {
          "name": "v",
          "type": "address",
          "internalType": "address"
        }
      ],
      "outputs": [],
      "stateMutability": "nonpayable"
    },
    {
      "type": "function",
      "name": "queueSlashWithProof",
      "inputs": [
        {
          "name": "operator",
          "type": "address",
          "internalType": "address"
        },
        {
          "name": "slashLevel",
          "type": "uint8",
          "internalType": "uint8"
        },
        {
          "name": "epoch",
          "type": "uint256",
          "internalType": "uint256"
        },
        {
          "name": "proof",
          "type": "bytes",
          "internalType": "bytes"
        }
      ],
      "outputs": [],
      "stateMutability": "nonpayable"
    },
    {
      "type": "function",
      "name": "removeValidator",
      "inputs": [
        {
          "name": "v",
          "type": "address",
          "internalType": "address"
        }
      ],
      "outputs": [],
      "stateMutability": "nonpayable"
    },
    {
      "type": "function",
      "name": "renounceOwnership",
      "inputs": [],
      "outputs": [],
      "stateMutability": "nonpayable"
    },
    {
      "type": "function",
      "name": "setBLSAggregator",
      "inputs": [
        {
          "name": "_bls",
          "type": "address",
          "internalType": "address"
        }
      ],
      "outputs": [],
      "stateMutability": "nonpayable"
    },
    {
      "type": "function",
      "name": "transferOwnership",
      "inputs": [
        {
          "name": "newOwner",
          "type": "address",
          "internalType": "address"
        }
      ],
      "outputs": [],
      "stateMutability": "nonpayable"
    },
    {
      "type": "function",
      "name": "version",
      "inputs": [],
      "outputs": [
        {
          "name": "",
          "type": "string",
          "internalType": "string"
        }
      ],
      "stateMutability": "pure"
    },
    {
      "type": "event",
      "name": "BLSAggregatorUpdated",
      "inputs": [
        {
          "name": "oldAddr",
          "type": "address",
          "indexed": true,
          "internalType": "address"
        },
        {
          "name": "newAddr",
          "type": "address",
          "indexed": true,
          "internalType": "address"
        }
      ],
      "anonymous": false
    },
    {
      "type": "event",
      "name": "OwnershipTransferred",
      "inputs": [
        {
          "name": "previousOwner",
          "type": "address",
          "indexed": true,
          "internalType": "address"
        },
        {
          "name": "newOwner",
          "type": "address",
          "indexed": true,
          "internalType": "address"
        }
      ],
      "anonymous": false
    },
    {
      "type": "event",
      "name": "ProposalCreated",
      "inputs": [
        {
          "name": "id",
          "type": "uint256",
          "indexed": true,
          "internalType": "uint256"
        },
        {
          "name": "operator",
          "type": "address",
          "indexed": true,
          "internalType": "address"
        },
        {
          "name": "level",
          "type": "uint8",
          "indexed": false,
          "internalType": "uint8"
        }
      ],
      "anonymous": false
    },
    {
      "type": "event",
      "name": "ProposalExecuted",
      "inputs": [
        {
          "name": "id",
          "type": "uint256",
          "indexed": true,
          "internalType": "uint256"
        }
      ],
      "anonymous": false
    },
    {
      "type": "event",
      "name": "ProposalSigned",
      "inputs": [
        {
          "name": "id",
          "type": "uint256",
          "indexed": true,
          "internalType": "uint256"
        },
        {
          "name": "validator",
          "type": "address",
          "indexed": true,
          "internalType": "address"
        }
      ],
      "anonymous": false
    },
    {
      "type": "event",
      "name": "ValidatorPruned",
      "inputs": [
        {
          "name": "v",
          "type": "address",
          "indexed": true,
          "internalType": "address"
        },
        {
          "name": "hadRole",
          "type": "bool",
          "indexed": false,
          "internalType": "bool"
        },
        {
          "name": "stakeAmount",
          "type": "uint256",
          "indexed": false,
          "internalType": "uint256"
        }
      ],
      "anonymous": false
    },
    {
      "type": "event",
      "name": "ValidatorRemoved",
      "inputs": [
        {
          "name": "v",
          "type": "address",
          "indexed": true,
          "internalType": "address"
        }
      ],
      "anonymous": false
    },
    {
      "type": "error",
      "name": "AlreadySigned",
      "inputs": []
    },
    {
      "type": "error",
      "name": "NotActiveValidator",
      "inputs": [
        {
          "name": "v",
          "type": "address",
          "internalType": "address"
        }
      ]
    },
    {
      "type": "error",
      "name": "NotAuthorizedExecutor",
      "inputs": []
    },
    {
      "type": "error",
      "name": "NotValidator",
      "inputs": []
    },
    {
      "type": "error",
      "name": "OnlyBLSAggregator",
      "inputs": []
    },
    {
      "type": "error",
      "name": "OwnableInvalidOwner",
      "inputs": [
        {
          "name": "owner",
          "type": "address",
          "internalType": "address"
        }
      ]
    },
    {
      "type": "error",
      "name": "OwnableUnauthorizedAccount",
      "inputs": [
        {
          "name": "account",
          "type": "address",
          "internalType": "address"
        }
      ]
    },
    {
      "type": "error",
      "name": "ProposalDoesNotExist",
      "inputs": []
    },
    {
      "type": "error",
      "name": "ProposalExecutedAlready",
      "inputs": []
    },
    {
      "type": "error",
      "name": "StakingNotConfigured",
      "inputs": []
    },
    {
      "type": "error",
      "name": "ValidatorMissingRole",
      "inputs": []
    },
    {
      "type": "error",
      "name": "ValidatorRoleRevoked",
      "inputs": [
        {
          "name": "v",
          "type": "address",
          "internalType": "address"
        }
      ]
    },
    {
      "type": "error",
      "name": "ValidatorStakeBelowMinimum",
      "inputs": [
        {
          "name": "actual",
          "type": "uint256",
          "internalType": "uint256"
        },
        {
          "name": "required",
          "type": "uint256",
          "internalType": "uint256"
        }
      ]
    },
    {
      "type": "error",
      "name": "ValidatorStillEligible",
      "inputs": [
        {
          "name": "v",
          "type": "address",
          "internalType": "address"
        }
      ]
    }
  ]
}